import { joinRows, rowMetrics } from '../GscTools/metrics';

/**
 * Block 03's rows, in whichever of the two shapes the windows allow.
 *
 * With a baseline that came back, the two windows are joined on the exact URL and ordered by the
 * size of the click movement — the shared join, so a page in only one window is not comparable
 * rather than new. Without one, the current window's rows are kept as Search Console returned
 * them, highest clicks first, because a list of pages is still worth reading when there is nothing
 * to subtract it from.
 */
export function pageRows({ currentRows, priorRows, comparing, hasPosition }) {
    if (comparing) return joinRows(currentRows, priorRows, hasPosition);

    return (currentRows ?? []).map((row) => {
        const key = row?.keys?.[0] ?? '';
        return { id: key, key, url: key, ...rowMetrics(row, hasPosition) };
    });
}

/** Block 04's rows: one per returned country, keyed by the code Search Console sent. */
export function countryRows(rows, hasPosition) {
    return (rows ?? []).map((row) => {
        const key = row?.keys?.[0] ?? '';
        return { id: key, key, ...rowMetrics(row, hasPosition) };
    });
}

/**
 * The weaker of the two page cursors decides whether more rows can still be asked for.
 *
 * A window whose cursor is exhausted — or whose request failed — simply stops contributing; the
 * other one can still be paged on.
 */
export function pagesStopReason(currentChunk, priorChunk) {
    const reasons = [currentChunk?.stopReason, priorChunk?.stopReason].filter(Boolean);

    if (!reasons.length) return 'empty_page';
    if (reasons.includes('more_available')) return 'more_available';
    if (reasons.includes('product_cap')) return 'product_cap';
    return 'empty_page';
}
